import React from 'react';
import {
    Dialog,
    DialogContent,
    IconButton,
    lighten,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ReviewWizard, { ExperienceType } from './ReviewWizard';

interface ReviewModalProps {
    open: boolean;
    onClose: () => void;
    bookingId: number;
    experienceType: ExperienceType;
    existingReview?: any;
}

const ReviewModal: React.FC<ReviewModalProps> = ({
    open,
    onClose,
    bookingId,
    experienceType,
    existingReview,
}) => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='md'
            fullWidth
            fullScreen={isMobile}
            PaperProps={{
                sx: {
                    borderRadius: isMobile ? 0 : 2,
                    maxHeight: '95vh',
                    overflow: 'hidden',
                },
            }}
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    zIndex: 1,
                }}
                aria-label='close'
            >
                <CloseIcon />
            </IconButton>

            <DialogContent
                sx={{
                    padding: 0,
                    overflow: 'auto',
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: `${theme.palette.neutral.main}`,
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: `${lighten(theme.palette.neutral.main, 0.5)}`,
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        background: `${lighten(theme.palette.neutral.main, 0.3)}`,
                    },
                }}
            >
                <ReviewWizard
                    bookingId={bookingId}
                    experienceType={experienceType}
                    existingReview={existingReview}
                    isReadOnly={existingReview?.published}
                    onSuccess={onClose}
                />
            </DialogContent>
        </Dialog>
    );
};

export default ReviewModal;
